export default class CdpDataHandler {
  signalChainGridData = {};
  parameterMappingData = null;

  constructor(signalChainGridData, parameterMappingData) {
    this.signalChainGridData = signalChainGridData;
    this.parameterMappingData = parameterMappingData;
  }

  get cdpParameters() {
    if (!this.parameterMappingData) return {};
    let result = {};

    Object.keys(this.parameterMappingData).forEach((paramId) => {
      const param = this.parameterMappingData[paramId];
      result[paramId] = param.minMaxTyp ? `${param.name} (${param.minMaxTyp})` : param.name;
    });

    return result;
  }
}
